import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ErrorComponent } from '../components/api-call-components/error/error.component';
import { LoadingComponent } from '../components/api-call-components/loading/loading.component';
import { LoadingIdicatorWrapperDirective } from './loading-indicator-wrapper.directive';

@NgModule({
  imports: [CommonModule, ErrorComponent, LoadingComponent, LoadingIdicatorWrapperDirective],
  exports: [LoadingIdicatorWrapperDirective],
  providers: [],
})
export class ApiCallModule { }
